const passwordCompareMessage = "* hasła muszą być jednakowe";

export { passwordCompareMessage };
